export class ServerDefine {
  //  测试服
  static GAME_TEST_SERVERS = [
    // "wss://159.75.98.83:30202"
    // "wss://test.vegasslot.one:30202"
    //"wss://wssdev.toppkwin.com"
    //"ws://159.75.98.83:30202"
    //"wss://test.wld-dev.online/ws"
    'wss://testdev20260323.big-win.one',
  ]

  //  正式服
  static GAME_SERVERS = [
    //"wss://wssproduction.toppkwin.com:30202"
    // "ws://13.200.101.120:30202"
    'wss://wssproduction2.toppkwin.com/ws',
  ]

  static SELF_GAME_URL_TEST = 'http://test.vegasslot.one/games/'
  static SELF_GAME_URL_RELEASE = 'https://888cash.bet/games/'

  static GAME_ICON_URL = 'https://siteresource.uk/icon_'
}
